/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { getGuarantorsType } from '@/services/pre-enrollment/types';

const mountGuarantorObj = (values: any): getGuarantorsType => {
  const guarantor: getGuarantorsType = {
    name: values.name,
    address: values.address,
    ...(values.address_complement && {
      address_complement: values.address_complement,
    }),
    birthdate: values.birthdate,
    birthplace: values.birthplace,
    city: values.city,
    cpf: values.cpf,
    ...(values.cpf_document_url && {
      cpf_document_url: values.cpf_document_url,
    }),
    degree_of_relatedness: values.degree_of_relatedness,
    ...(values.document_selfie_url && {
      document_selfie_url: values.document_selfie_url,
    }),
    email: values.email,
    marital_regime: values.marital_regime,
    marital_status: values.marital_status,
    nationality: values.nationality,
    neighborhood: values.neighborhood,
    phone_number: values.phone_number,
    politically_exposed_person: values.politically_exposed_person,
    ...(values.proof_of_residency_document_url && {
      proof_of_residency_document_url: values.proof_of_residency_document_url,
    }),
    residence_number: values.residence_number,
    residence_type: values.residence_type,
    rg: values.rg,
    ...(values.rg_document_url && {
      rg_document_url: values.rg_document_url,
    }),
    rg_issuing_body: values.rg_issuing_body,
    rg_issuing_state: values.rg_issuing_state,
    state: values.state,
    zipcode: values.zipcode,
    degree_of_relatedness_other: values.degree_of_relatedness_other,
    id: values.id,
  };

  return guarantor;
};

export default mountGuarantorObj;
